import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GoldPriceTable from '@/components/feature/GoldPriceTable';
import PriceChart from '@/components/feature/PriceChart';
import Hero from './components/Hero';
import Features from './components/Features';
import NewsSection from './components/NewsSection';
import GoldTicker from './components/GoldTicker';

const stats = [
  { value: '120.000+', label: 'Nhà đầu tư' },
  { value: '8.500 tỷ', label: 'Khối lượng giao dịch' },
  { value: '99,9%', label: 'Thời gian hoạt động' },
  { value: '10+', label: 'Năm kinh nghiệm' },
];

const steps = [
  { num: '01', icon: 'ri-user-add-line', title: 'Đăng ký tài khoản', desc: 'Tạo tài khoản và xác minh danh tính trong vài phút.' },
  { num: '02', icon: 'ri-bank-card-line', title: 'Nạp tiền', desc: 'Liên kết ngân hàng và nạp tiền vào tài khoản giao dịch.' },
  { num: '03', icon: 'ri-exchange-funds-line', title: 'Giao dịch vàng', desc: 'Mua bán vàng với giá khớp lệnh minh bạch theo thời gian thực.' },
  { num: '04', icon: 'ri-wallet-3-line', title: 'Quản lý tài sản', desc: 'Theo dõi tài sản, lợi nhuận và rút tiền mọi lúc mọi nơi.' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <GoldTicker />
      <main>
        <Hero />

        <section className="mx-auto max-w-6xl px-4 md:px-6 -mt-6 relative z-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 rounded-xl border border-background-200/60 bg-background-100 p-5 md:p-6">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <p className="text-xl md:text-2xl font-bold text-gold-gradient whitespace-nowrap">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Bảng giá vàng hôm nay</h2>
            <p className="mt-2 text-foreground-600">Cập nhật lúc 09:15 · 15/08/2026</p>
          </div>
          <GoldPriceTable />
          <div className="mt-4 text-center">
            <Link to="/thi-truong" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-400 hover:text-primary-300 cursor-pointer whitespace-nowrap">
              Xem toàn bộ thị trường <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 md:px-6 pb-14 md:pb-20">
          <PriceChart />
        </section>

        <Features />

        <section className="border-t border-background-200/60 bg-background-100">
          <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Bắt đầu đầu tư vàng trong 4 bước</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {steps.map((s) => (
                <div key={s.num} className="relative rounded-xl border border-background-200/60 bg-background-50 p-5">
                  <span className="absolute top-4 right-4 text-2xl font-bold text-background-300">{s.num}</span>
                  <div className="w-11 h-11 rounded-lg bg-accent-500/15 flex items-center justify-center mb-4">
                    <i className={`${s.icon} text-accent-400 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950">{s.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <NewsSection />

        <section className="mx-auto max-w-6xl px-4 md:px-6 pb-14 md:pb-20">
          <div className="relative overflow-hidden rounded-2xl border border-primary-500/30 bg-gradient-to-br from-background-100 to-primary-500/10 p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Sẵn sàng đầu tư vàng ngay hôm nay?</h2>
            <p className="mt-3 text-foreground-600 max-w-xl mx-auto">Tham gia cùng hơn 120.000 nhà đầu tư đang giao dịch vàng trên Goldsbvvn.</p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/dang-nhap" className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors">
                Tạo tài khoản miễn phí
              </Link>
              <Link to="/lien-he" className="w-full sm:w-auto px-7 py-3 rounded-md border border-background-400 text-foreground-800 font-semibold text-sm hover:border-primary-500 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors">
                Liên hệ hỗ trợ
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}